// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CodeIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from code.svg
 */
export default function CodeIcon(props: CodeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CodeIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M12.707 4.293a1 1 0 1 0-1.414 1.414L13.586 8l-2.293 2.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414zm-9.414 0a1 1 0 0 1 1.414 1.414L2.414 8l2.293 2.293a1 1 0 1 1-1.414 1.414l-3-3a1 1 0 0 1 0-1.414z"
          clip-rule="evenodd"
        />
      </g>
    </svg>
  );
}
